module.exports = __webpack_public_path__ + "img/vod-banner.63c76b2c.png";